import React, { useState } from "react";
import Input from "../../components/Form/Input";
import Dropdown from "../../components/Form/Dropdown";
import CustomButton from "../../components/Buttons/CustomButton";
import showToast from "../../utils/toastNotifications";
import { formStyles } from "../../components/Form/FormUtils";
import { useThunk } from "../../hooks/useThunk";
import { createSubscriptionAdjustment } from "../../services/thunks/subscriptionThunks";

const options = [
  { _id: "Subscription Cancel", name: "Subscription Cancel" },
  { _id: "refund", name: "Refund" },
];

const SubscriptionAmountAdjustment = ({ onSuccess }) => {
  const [option, setOption] = useState(null);
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const [doCreateAdjustment, isCreating] = useThunk(createSubscriptionAdjustment);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selected = option ? option._id || option : null;
    if (!selected || !["Subscription Cancel", "refund"].includes(selected)) {
      showToast("error", "Please select a valid option.");
      return;
    }

    // Convert amount to number
    const numericAmount = Number(amount);
    
    // Validate amount is required and greater than 0
    if (!amount || isNaN(numericAmount) || numericAmount <= 0) {
      showToast("error", "Please enter a valid amount greater than 0.");
      return;
    }

    const payload = {
      option: selected,
      amount: numericAmount,
      reason: reason || "",
    };

    try {
      setLoading(true);
      const result = await doCreateAdjustment(payload);
      if (result && result.success) {
        showToast("success", result.response?.message || "Adjustment created");
        setOption(null);
        setAmount("");
        setReason("");
        setResetKey(prev => prev + 1);
        if (onSuccess) onSuccess();
      } else {
        showToast("error", result?.error?.message || "Failed to create adjustment");
      }
    } catch (err) {
      console.error(err);
      showToast("error", err?.message || "Failed to create adjustment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full bg-[#111111d6] border border-[#505050] rounded-[8px] p-5 mb-6"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Dropdown
            key={resetKey}
            options={options}
            placeholder="Select option"
            defaultOption={option}
            onSelect={(val) => setOption(val)}
            label="Option"
            isSearchable={false}
            labelStyle="text-[14px]"
          />
        </div>

        <div>
          <Input
            label="Amount"
            placeholder="0.00"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            type="number"
            step="0.01"
            labelStyle="text-[14px]"
            className="cursor-default"
            inputStyle={formStyles.addTrackInput}
          />
        </div>

        <div>
          <Input
            label="Reason"
            placeholder="Optional reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            labelStyle="text-[14px]"
            className="cursor-default"
            inputStyle={formStyles.addTrackInput}
          />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-end">
        <CustomButton type="submit" disabled={loading || isCreating} className="px-4 py-2">
          {loading || isCreating ? "Submitting..." : "Apply Adjustment"}
        </CustomButton>
      </div>
    </form>
  );
};

export default SubscriptionAmountAdjustment;
